import axios from 'axios'

// 设置sessionId 用户身份
let sessionId = localStorage.getItem('sessionId')
axios.defaults.headers.common['sessionId'] = sessionId;

const baseUrl = '/web'

// 装修攻略tab
export const findStrategyIndex = params => axios.get(`/strategyCurrency/findStrategyIndex`, { params: params })
// 攻略列表 分页
export const findPage = params => axios.get(`/strategyCurrency/findPage`, { params: params })
// 攻略详情
export const detailsByStrategyId = params => axios.get(`/strategyCurrency/detailsByStrategyId`, { params: params })
// 是否点赞
export const isThumbs = params => axios.get(`/UserThumbsController/isThumbs`, { params: params })
// 是否收藏
export const isCollect = params => axios.get(`/UserThumbsController/isCollect`, { params: params })
// 收藏
export const addCollect = params => axios.get(`/UserThumbsController/addCollect`, { params: params })
// 点赞
export const thumbs = params => axios.get(`/UserThumbsController/thumbs`, { params: params })
// 专业回答相关
export const isBuyMajorAnswer = params => axios.get(`/strategy/isBuyMajorAnswer`, { params: params })
// 写回答权限
export const judgeIsMajorAnswer = params => axios.get(`/strategy/judgeIsMajorAnswer`, { params: params })

// 评论
export const insertCommentStrategy = params => axios.post(`/sys/sysComment/insertCommentStrategy`, params)

// 是否可以打赏
export const isRewardCommentAnswer = params => axios.get(`/strategy/isRewardCommentAnswer`, { params: params })
// 打赏
export const rewardCommentAnswer = params => axios.get(`/strategy/rewardCommentAnswer`, { params: params })
// 获取专业回答详情
export const lookMajorAnswer = params => axios.get(`/strategy/lookMajorAnswer`, { params: params })
// 我有疑问
export const userIsComplaintMajorAnswer = params => axios.get(`/strategy/userIsComplaintMajorAnswer`, { params: params })
// 标准详情
export const getDetailsById = params => axios.get(`/strategyStandard/getDetailsById`, { params: params })
// 类型
export const findStrategyType = params => axios.get(`/strategyCurrency/findStrategyType`, { params: params })

// 问答
export const sendQuestion = params => axios.post(`/strategy/sendQuestion`, params)
// 单图上传
export const singleDes = params => axios.post(`/strategyCurrency/singleDes`, params)
// 多图上传
export const singleAllDes = params => axios.post(`/strategyCurrency/singleAllDes`, params)
//oss多图上传
export const singleAllDeStrategy = params => axios.post(`/auth/update/singleAllDeStrategy`, params)
// 曝光
export const sendExposure = params => axios.post(`/strategy/sendExposure`, params)
// 经验
export const sendExperience = params => axios.post(`/strategy/sendExperience`, params)

// 对应标准
export const getAllStandard = params => axios.get(`/strategyStandard/getAllStandard`, { params: params })
//专业回答
export const sdpSendMajorAnswer = params => axios.post(`/strategy/sdpSendMajorAnswer`, params)

// 获取金币数
export const goldCoin = params => axios.get(`/strategy/goldCoin`, { params: params })
// 微信支付
export const payAnswer = params => axios.get(`/strategyPay/payAnswer`, { params: params })
// 金币支付
export const userBuyMajorAnswer = params => axios.get(`/strategy/userBuyMajorAnswer`, { params: params })
// 金币账单
export const findGoldCoinBillList = params => axios.get(`/strategy/findGoldCoinBillList`, { params: params })
// 金币 赞跳板
export const findSpringboardCommentsId = params => axios.get(`/sys/sysComment/findSpringboardCommentsId`, { params: params })
// 评论 收到的回答跳板
export const findSpringboardCommentsStrategy = params => axios.get(`/sys/sysComment/findSpringboardCommentsStrategy`, { params: params })
// 我的关注
export const findCollectList = params => axios.get(`/UserThumbsController/findCollectList`, { params: params })
// 我的发布
export const findSendQuestionList = params => axios.get(`/strategy/findSendQuestionList`, { params: params })
// 已购回答
export const findBuyMajorList = params => axios.get(`/strategy/findBuyMajorList`, { params: params })
// 我的回答
export const myMajorList = params => axios.get(`/strategy/myMajorList`, { params: params })
// 金币消息是否未读
export const haveNotHandle = params => axios.get(`/strategy/haveNotHandle`, { params: params })
// 金币已读
export const signIsHandle = params => axios.post(`/strategy/signIsHandle`, params)
//装修问答(专业回答) - 未购买用户 专业回答返回一半的专业回答
export const lookMajorAnswerHalf = params => axios.get(`/strategy/lookMajorAnswerHalf`, { params: params })
//现场参与人员 - 根据项目 id 获取目录一级的标准目录
export const getProceOne = params => axios.get(`/worker/getProceOne`, { params: params })
//现场参与人员 - 查询可配置的所有 参与人员类型
export const findUserWorkerShow = params => axios.get(`/worker/findUserWorkerShow`, { params: params })
//现场参与人员 - 获取二维码
export const getJoinWorkersImg = params => axios.get(`/worker/getJoinWorkersImg`, { params: params })
//现场参与人员 - 生成二维码
export const setJoinWorkersImg = params => axios.post(`/worker/setJoinWorkersImg`, params)
//监理 - 根据标准id获取标准详情(包含未上架的)
export const getDetailsById2 = params => axios.get(`/personalCenterSdp/getDetailsById2`, { params: params })


// WEBPACK FOOTER //
// ./src/api/strategyApi.js